export default __webpack_public_path__ + "static/media/monthly-icon.d855eb7a.svg";